"use client";

import { Link } from "@/i18n/routing";
import Image from "next/image";

import { resolveImageUrl } from "@/lib/utils";
import { ProjectShareHoverMenu } from "@/components/projects/ProjectShareHoverMenu";

import type { NewsArticle } from "@/types";

function getArticlePathname(id: number) {
  return `/news/${id}`;
}

export function NewsCard({
  locale,
  article,
  title,
}: {
  locale: string;
  article: NewsArticle;
  title: string;
}) {
  const href = getArticlePathname(article.Id);
  const imageId = article.ImageId || article.MainImageId;
  const imageUrl = resolveImageUrl({
    imageUrl: article.ImageUrl ?? article.MainImageUrl ?? null,
    imageId,
  });

  const localizedHref = `/${locale}${href}`;
  const shareUrl =
    typeof window !== "undefined"
      ? `${window.location.origin}${localizedHref}`
      : localizedHref;

  return (
    <div className="block overflow-hidden rounded-2xl border bg-white shadow-sm transition-shadow hover:shadow-md">
      <div className="relative">
        {(article.ImageUrl || article.MainImageUrl || imageId) ? (
          <Link href={href} className="block">
            <div className="relative aspect-[4/3] bg-gray-100">
              <Image
                src={imageUrl}
                alt={title}
                fill
                className="object-cover"
              />
            </div>
          </Link>
        ) : (
          <Link href={href} className="block">
            <div className="aspect-[4/3] bg-gray-200" />
          </Link>
        )}

 

        <ProjectShareHoverMenu
          url={shareUrl}
          text={title}
          shareSegmentClassName="bg-association-theme-2 hover:brightness-110"
          className="projectShare absolute top-2 left-2 z-20 rtl:left-auto rtl:right-2"
        />
      </div>

      <Link
        href={href}
        className="block bg-success p-4"
      >
        <div className="line-clamp-2 text-right text-base font-bold leading-relaxed text-white">
          {title}
        </div>
      </Link>
    </div>
  );
}
